import { Union } from "../../fable_modules/fable-library-js.4.18.0/Types.js";
import { union_type, anonRecord_type, array_type, unit_type, int32_type, tuple_type, list_type, lambda_type, obj_type, class_type, string_type, bool_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";
import { CSSProp_$reflection } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { toProps } from "../React.fs.js";
import * as react from "react";
import { Select as Select_1 } from "antd";

export class SelectProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AllowClear", "AutoClearSearchValue", "AutoFocus", "Bordered", "ClassName", "ClearIcon", "DefaultActiveFirstOption", "DefaultOpen", "DefaultValue", "Disabled", "DropdownClassName", "DropdownMatchSelectWidth", "DropdownRender", "DropdownStyle", "FilterOption", "FilterSort", "LabelInValue", "ListHeight", "Loading", "MaxTagCount", "MaxTagPlaceholder", "MaxTagTextLength", "MenuItemSelectedIcon", "Mode", "NotFoundContent", "OnBlur", "OnChange", "onChange", "OnDeselect", "OnDropdownVisibleChange", "OnFocus", "OnInputKeyDown", "OnMouseEnter", "OnMouseLeave", "OnPopupScroll", "OnSearch", "OnSelect", "Open", "OptionFilterProp", "OptionLabelProp", "Options", "Placeholder", "RemoveIcon", "SearchValue", "ShowArrow", "ShowSearch", "SuffixIcon", "TagRender", "TokenSeparators", "Value", "value", "Virtual"];
    }
}

export function SelectProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Select.SelectProps", [], SelectProps, () => [[["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", lambda_type(obj_type, class_type("Fable.React.ReactElement"))]], [["Item", list_type(CSSProp_$reflection())]], [["Item", bool_type]], [["Item", lambda_type(tuple_type(class_type("Loop54.Portal.WebUI.Interop.Antd.Select.IOption"), class_type("Loop54.Portal.WebUI.Interop.Antd.Select.IOption")), int32_type)]], [["Item", bool_type]], [["Item", int32_type]], [["Item", bool_type]], [["Item", int32_type]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", int32_type]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", string_type]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", lambda_type(string_type, unit_type)]], [["Item", lambda_type(array_type(string_type), unit_type)]], [["Item", lambda_type(tuple_type(string_type, class_type("Loop54.Portal.WebUI.Interop.Antd.Select.IOption")), unit_type)]], [["Item", lambda_type(bool_type, unit_type)]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", lambda_type(string_type, unit_type)]], [["Item", lambda_type(tuple_type(string_type, class_type("Loop54.Portal.WebUI.Interop.Antd.Select.IOption")), unit_type)]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", array_type(anonRecord_type(["label", string_type], ["value", string_type]))]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", lambda_type(obj_type, class_type("Fable.React.ReactElement"))]], [["Item", array_type(string_type)]], [["Item", string_type]], [["Item", array_type(string_type)]], [["Item", bool_type]]]);
}

export function Select(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Select_1, props_1, ...elems);
}

export class SelectOptionProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Classname", "Disabled", "Title", "Value"];
    }
}

export function SelectOptionProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Select.SelectOptionProps", [], SelectOptionProps, () => [[["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export function SelectOption(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Select_1.Option, props_1, ...elems);
}

export class OptGroupProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Key", "Label"];
    }
}

export function OptGroupProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Select.OptGroupProps", [], OptGroupProps, () => [[["Item", string_type]], [["Item", class_type("Fable.React.ReactElement")]]]);
}

export function SelectOptGroup(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Select_1.OptGroup, props_1, ...elems);
}

